import { useMediaQuery } from '@mui/material';

// Phone detection for the mobile views. Width alone misses phone landscape
// (712-932px wide), which used to drop a rotated phone into the desktop
// layout and wipe the mobile view's state on rotate-back. The second clause
// (short height + coarse pointer) catches landscape phones without pulling
// tablets — taller than 480px in both orientations — out of desktop.
const useIsMobileDevice = () => useMediaQuery(
  '(max-width:480px), ((max-height:480px) and (pointer:coarse))',
);

export default useIsMobileDevice;
